import { createContext, ReactNode } from 'react';

export interface ModalContextType {
  isOpen: boolean;
  modalContent: ReactNode | null;
  modalSize?: 'small' | 'default' | 'large';
  customClasses?: string;
  openModal: (
    content: ReactNode,
    sizeOrClasses?: 'small' | 'default' | 'large' | string
  ) => void;
  closeModal: () => void;
}

export const ModalContext = createContext<ModalContextType | undefined>(undefined);
